<div class="images-holder">
  <img *ngFor="let image of images | slice : 1" [pyMedia]="image" [alt]="image.altText" loading="lazy" />
  <span class="items-count" *ngIf="itemsCount"
    ><span>+{{ itemsCount }}</span></span
  >
</div>
